var map = {
	"./calendar/calendar.module": [
		"./src/app/main/apps/calendar/calendar.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~offi~61290011",
		"default~calendar-calendar-module~events-events-module",
		"calendar-calendar-module"
	],
	"./chat/chat.module": [
		"./src/app/main/apps/chat/chat.module.ts",
		"default~chat-chat-module~events-events-module~mail-mail-module~office365-office365-module",
		"chat-chat-module"
	],
	"./contacts/contacts.module": [
		"./src/app/main/apps/contacts/contacts.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~offi~61290011",
		"default~contacts-contacts-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~contacts-contacts-module~mail-mail-module",
		"contacts-contacts-module"
	],
	"./dashboards/analytics/analytics.module": [
		"./src/app/main/apps/dashboards/analytics/analytics.module.ts",
		"default~dashboards-analytics-analytics-module~dashboards-project-project-module",
		"dashboards-analytics-analytics-module"
	],
	"./dashboards/project/project.module": [
		"./src/app/main/apps/dashboards/project/project.module.ts",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"default~dashboards-analytics-analytics-module~dashboards-project-project-module",
		"dashboards-project-project-module"
	],
	"./events/events.module": [
		"./src/app/main/apps/events/events.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~offi~61290011",
		"default~contacts-contacts-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~chat-chat-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~events-events-module~mail-mail-module~office365-office365-module",
		"default~calendar-calendar-module~events-events-module",
		"events-events-module"
	],
	"./mail-ngrx/mail.module": [
		"./src/app/main/apps/mail-ngrx/mail.module.ts",
		"mail-ngrx-mail-module"
	],
	"./mail/mail.module": [
		"./src/app/main/apps/mail/mail.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~offi~61290011",
		"default~contacts-contacts-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~chat-chat-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~events-events-module~mail-mail-module~office365-office365-module",
		"default~contacts-contacts-module~mail-mail-module",
		"mail-mail-module"
	],
	"./main/apps/apps.module": [
		"./src/app/main/apps/apps.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"main-apps-apps-module"
	],
	"./office365/office365.module": [
		"./src/app/main/apps/office365/office365.module.ts",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~main~f981e5c6",
		"default~contacts-contacts-module~dashboards-project-project-module~events-events-module~mail-mail-mo~511ede07",
		"default~calendar-calendar-module~contacts-contacts-module~events-events-module~mail-mail-module~offi~61290011",
		"default~contacts-contacts-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~chat-chat-module~events-events-module~mail-mail-module~office365-office365-module",
		"default~events-events-module~mail-mail-module~office365-office365-module",
		"office365-office365-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;